import { Button, HStack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useRoundSelection } from "./RoundSelectionContext";
import { stageLabel } from "./stageLabel";

export const EarlierRoundNotice = () => {
  const { t } = useTranslation();
  const { selectedRound, currentRound, selectRound } = useRoundSelection();
  const isEarlier = currentRound != null && (selectedRound?.roundNumber ?? 0) < currentRound.roundNumber;
  if (!isEarlier) return null;

  return (
    <HStack spacing="3" wrap="wrap" role="status">
      <Text fontSize="sm" color="smMuted">
        {t("This is an earlier round. The current one is {{round}}.", { round: stageLabel(t, currentRound) })}
      </Text>
      <Button variant="link" colorScheme="teal" size="sm" onClick={() => selectRound(currentRound)}>
        {t("Go to the current round")}
      </Button>
    </HStack>
  );
};
